import type { FormEvent } from 'react';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { WashCycleService } from '../../../../services';
import { SimpleBox } from '../../../atoms';

export function AddWashCycle(): React.JSX.Element {
  const [code, setCode] = useState<string>('');

  const handleAddWashCycle = async (): Promise<void> => {
    const addWashCycleResponse = await WashCycleService.addWashCycle(code);
    if (addWashCycleResponse.error) {
      toast.error('Fehler beim Eintragen des Waschzyklus 😩');
      console.log(addWashCycleResponse.message);

      return;
    }

    setCode('');
    toast.success('Waschzyklus ergänzt ✅');
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
  };

  const handleKeyPress = (key: string): void => {
    if (key === 'Enter') {
      handleAddWashCycle();
    }
  };

  return (
    <div className='container mt-10'>
      <div className='row'>
        <div className='col-12'>
          <SimpleBox>
            <h4>Waschzyklus hinzufügen</h4>
            <Form onSubmit={handleSubmit}>
              <Form.Group className='mt-4 mb-3' controlId='formGroupClothCode'>
                <Form.Control
                  type='text'
                  placeholder='Code...'
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  onKeyDown={(e) => handleKeyPress(e.key)}
                ></Form.Control>
              </Form.Group>
              <Form.Group controlId='formGroupAdd'>
                <Button onClick={() => handleAddWashCycle()}>Hinzufügen</Button>
              </Form.Group>
            </Form>
          </SimpleBox>
        </div>
      </div>
    </div>
  );
}
